import { render, staticRenderFns } from "./TaxCodeSelector.yaml?vue&type=template&id=57142c7d&component"
import script from "./TaxCodeSelector.yaml?vue&type=script&lang=ts&component"
export * from "./TaxCodeSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports